import { linkToOfferScreen } from '@features/offers/utils/helpers';
import { useUpsellStepFlow } from '@hooks';
import { LayoutConfirmationFooter } from '@molecules';
import { PageHeader } from '@organisms';
import { Button, Row, Spin } from 'antd';
import React from 'react';

import { ConfirmModal } from '../../components/ConfirmModal';
import { FlowSteps } from '../../components/FlowSteps';
import { ManageEdgeModal } from '../../components/ManageEdgeModal';
import { ManageFlowDrawer } from '../../components/ManageFlowDrawer';
import { ManageStepModal } from '../../components/ManageStepModal';
import { TableFlowSteps } from '../../components/TableFlowSteps';

export const UpsellStepFlow: React.FC = () => {
  const {
    upsellFlow,
    allFlowSteps,
    isLoading,
    createStepModal,
    onOpenStepCreateModal,
    manageStepModal,
    onOpenManageStepModal,
    addChangeStep,
    saveUpdatesPage,
    onOpenModalDeleteStep,
    deleteStepModal,
    onOpenModalEditStep,
    isOpenManageFlowDrawer,
    onOpenManageFlowDrawer,
    onCloseManageFlowDrawer,
    isLoadingManageFlowDrawerTable,
    flowOffers,
    navigate,
  } = useUpsellStepFlow();

  return (
    <LayoutConfirmationFooter
      onCancel={() => navigate(-1)}
      onSave={saveUpdatesPage}
      isLoadingSave={isLoading}
      cancelLabelButton='Cancelar'
      ableToSave={!isLoading}
      continueLabelButton={'Aplicar'}
    >
      {!upsellFlow || isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh',
          }}
        >
          <Spin size='large' />
        </div>
      ) : (
        <>
          <PageHeader
            backToPath={() => {
              navigate(-1);
            }}
            title={upsellFlow.name}
            subTitle={'Gerencie, edite e crie novas etapas de Funil.'}
          />
          <Row>
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                width: '100%',
              }}
            >
              <Button
                type='primary'
                onClick={onOpenManageFlowDrawer}
                style={{ marginBottom: '20px' }}
              >
                Gerenciar Ofertas Vinculadas
              </Button>
            </div>
          </Row>
          <FlowSteps
            steps={allFlowSteps}
            onChangeStep={addChangeStep}
            onCreateEdge={onOpenManageStepModal}
            onCreateStep={onOpenStepCreateModal}
            onDeleteStep={onOpenModalDeleteStep}
            onEditStep={onOpenModalEditStep}
          />
          <TableFlowSteps flowSteps={allFlowSteps} />

          {createStepModal && <ManageStepModal {...createStepModal} />}
          {manageStepModal && <ManageEdgeModal {...manageStepModal} />}
          {deleteStepModal && <ConfirmModal {...deleteStepModal} />}
          <ManageFlowDrawer
            isLoading={isLoadingManageFlowDrawerTable}
            flowOffers={flowOffers}
            isOpen={isOpenManageFlowDrawer}
            onClose={onCloseManageFlowDrawer}
            onOpenOffer={(offerId, productId) => {
              // Abre página de visualização da oferta em nova aba
              window.open(
                linkToOfferScreen(offerId, productId, 'view'),
                '_blank'
              );
            }}
          />
        </>
      )}
    </LayoutConfirmationFooter>
  );
};
